import * as React from 'react'
import { t } from 'ttag'
import { ReactComponent as GoalsIcon } from '../../assets/v2/icons/menu-goals.svg'
import { ReactComponent as BenefitsIcon } from '../../assets/v2/icons/menu-benefits.svg'
import { ReactComponent as StatisticsIcon } from '../../assets/v2/icons/menu-statistics.svg'
import { ReactComponent as CompaniesIcon } from '../../assets/v2/icons/menu-companies.svg'
import { ReactComponent as UserManagementIcon } from '../../assets/v2/icons/user-management.svg'
import { ReactComponent as YourDetailsIcon } from '../../assets/v2/icons/your-details.svg'
//import { Role } from '../../services/api.types'
import ActivityWrapper from '../../views/Activity/ActivityWrapper'
import CompanyRankingWrapper from '../../views/CompanyRanking/CompanyRankingWrapper'
//import BenefitsManagementWrapper from '../../views/BenefitsManagement/BenefitsManagementWrapper'
//import BenefitsManagementNewWrapper from '../../views/BenefitsManagement/children/BenefitsManagementNew/BenefitsManagementNewWrapper'
import ForgotPasswordWrapper from '../../views/ForgotPassword/ForgotPasswordWrapper'
import IntegrationProxyWrapper from '../../views/IntegrationProxies/IntegrationProxyWrapper'
import LoginWrapper from '../../views/Login/LoginWrapper'
import RegisterUserWrapper from '../../views/RegisterUser/RegisterUserWrapper'
import ResetPasswordWrapper from '../../views/ResetPassword/ResetPasswordWrapper'
import SettingsWrapper from '../../views/Settings/SettingsWrapper'
import ProgressWrapper from '../../views/Progress/ProgressWrapper'
import StatisticsWrapper from '../../views/Statistics/StatisticsWrapper'
import UserManagementWrapper from '../../views/UserManagement/containers/UserManagement/UserManagementWrapper'
//import UserManagementNewWrapper from '../../views/UserManagement/containers/UserManagementNew/UserManagementNewWrapper'
import SignUpWrapper from '../../views/SignUp/SignUpWrapper'
import WelcomeWrapper from '../../views/Welcome/WelcomeWrapper'
import AppProxyWrapper from '../../components/YumGoogleSignIn/AppProxyWrapper'
import ChallengeChatWrapper from '../../views/ChallengeChat/ChallengeChatWrapper'
import ChallengeAdminWrapper from '../../views/ChallengeAdmin/ChallengeAdminWrapper'
import { Role } from '../../services/api.types'
import ChallengeInfoWrapper from '../../views/ChallengeInfo/ChallengeInfoWrapper'
import ChallengeMeWrapper from '../../views/ChallengeMe/ChallengeMeWrapper'
import ChallengeRankingWrapper from '../../views/ChallengeRanking/ChallengeRankingWrapper'
import DashboardWrapper from '../../views/Dashboard/DashboardWrapper'
import WebProxyWrapper from '../../components/YumGoogleSignIn/WebProxyWrapper'
import UserAdminWrapper from '../../views/UserManagement/containers/UserAdmin/UserAdminWrapper'

// REMOVE LAZY-LOADING TEMPORARILY
/*
const ActivityWrapper = React.lazy(() => import('../../views/Activity/ActivityWrapper'))
const BenefitsWrapper = React.lazy(() => import('../../views/Benefits/BenefitsWrapper'))
const BenefitsManagementNewWrapper = React.lazy(() =>
  import('../../views/BenefitsManagement/containers/BenefitsManagementNew/BenefitsManagementNewWrapper'),
)
const BenefitsManagementWrapper = React.lazy(() =>
  import('../../views/BenefitsManagement/containers/BenefitsManagement/BenefitsManagementWrapper'),
)
const ForgotPasswordWrapper = React.lazy(() => import('../../views/ForgotPassword/ForgotPasswordWrapper'))
const IntegrationProxyWrapper = React.lazy(() => import('../../views/IntegrationProxies/IntegrationProxyWrapper'))
const LandingWrapper = React.lazy(() => import('../../views/Landing/LandingWrapper'))
const LoginWrapper = React.lazy(() => import('../../views/Login/LoginWrapper'))
const PrivacyPolicy = React.lazy(() => import('../../views/PrivacyPolicy/PrivacyPolicy'))
const RegisterUserWrapper = React.lazy(() => import('../../views/RegisterUser/RegisterUserWrapper'))
const ResetPasswordWrapper = React.lazy(() => import('../../views/ResetPassword/ResetPasswordWrapper'))
const SettingsWrapper = React.lazy(() => import('../../views/Settings/SettingsWrapper'))
const StatisticsWrapper = React.lazy(() => import('../../views/Statistics/StatisticsWrapper'))
const UserManagementNewWrapper = React.lazy(() =>
  import('../../views/UserManagement/containers/UserManagementNew/UserManagementNewWrapper'),
)
const UserManagementWrapper = React.lazy(() =>
  import('../../views/UserManagement/containers/UserManagement/UserManagementWrapper'),
)
 */

export interface IRoute {
  component?: any
  title: string
  shortTitle?: string
  to: string
  //icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | undefined
  icon?: any
  inNavigation?: boolean
  isPublic?: boolean
  roles: Role[]
}

export const ROUTES: { [key: string]: IRoute } = {
  /*LANDING: {
    component: LoginWrapper,
    shortTitle: t`Login`,
    title: t`Login`,
    to: '/login',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },*/
  LANDING: {
    component: WelcomeWrapper,
    title: '',
    to: '/',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  LOGIN: {
    component: LoginWrapper,
    title: '',
    to: '/login',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  SIGNUP: {
    component: SignUpWrapper,
    title: '',
    to: '/signup',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  REGISTER_USER: {
    component: RegisterUserWrapper,
    title: '',
    to: '/register-user',
    roles: [Role.AUTHENTICATED],
    isPublic: true,
  },
  FORGOT_PASSWORD: {
    component: ForgotPasswordWrapper,
    title: '',
    to: '/forgot-password',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  RESET_PASSWORD: {
    component: ResetPasswordWrapper,
    title: '',
    to: '/reset-password',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  INTEGRATION_PROXY: {
    component: IntegrationProxyWrapper,
    shortTitle: t`Integration Proxy`,
    title: t`Integration Proxy`,
    to: '/integration-proxy',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  APP_PROXY: {
    component: AppProxyWrapper,
    shortTitle: t`Integration Proxy`,
    title: t`Integration Proxy`,
    to: '/app-proxy/*',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  WEB_PROXY: {
    component: WebProxyWrapper,
    shortTitle: t`Integration Proxy`,
    title: t`Integration Proxy`,
    to: '/web-proxy/*',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    isPublic: true,
  },
  CLIENT_PROGRESS: {
    component: ProgressWrapper,
    icon: StatisticsIcon,
    shortTitle: t`Progress`,
    title: t`Progress`,
    to: '/progress',
    //roles: [Role.USER],
    roles: [Role.AUTHENTICATED],
    inNavigation: true,
  },
  CLIENT_ACTIVITY: {
    component: ActivityWrapper,
    icon: GoalsIcon,
    shortTitle: t`Challenges`,
    title: t`Challenges`,
    to: '/challenges',
    roles: [Role.AUTHENTICATED],
    inNavigation: true,
  },
  CHALLENGE_LEADERBOARD: {
    component: ActivityWrapper,
    shortTitle: t`Leaderboard`,
    title: t`Leaderboard`,
    to: '/leaderboard/:goalId/:token',
    roles: [Role.ANONYMOUS, Role.AUTHENTICATED],
    inNavigation: false,
  },
  CLIENT_SPECIFIC_ACTIVITY: {
    component: ActivityWrapper,
    icon: GoalsIcon,
    shortTitle: t`Goals`,
    title: t`Goals`,
    to: '/activity/:goalId',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },
  CLIENT_SPECIFIC_ACTIVITY_INFO: {
    component: ChallengeInfoWrapper,
    icon: GoalsIcon,
    title: t`Challenges`,
    to: '/challenges/:goalId/info',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },
  /*CLIENT_SPECIFIC_ACTIVITY_YOU: {
    component: ChallengeMeWrapper,
    icon: GoalsIcon,
    title: t`Challenges`,
    to: '/challenges/:goalId/you',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },*/
  CLIENT_SPECIFIC_ACTIVITY_RANKING: {
    component: ChallengeRankingWrapper,
    icon: GoalsIcon,
    title: t`Challenges`,
    to: '/challenges/:goalId/ranking',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },
  CLIENT_SPECIFIC_ACTIVITY_CHAT: {
    component: ChallengeChatWrapper,
    icon: GoalsIcon,
    shortTitle: t`Goals`,
    title: t`Goals`,
    to: '/challenges/:goalId/chat',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },
  ADMIN_DASHBOARD: {
    component: DashboardWrapper,
    icon: BenefitsIcon,
    shortTitle: t`Statistics`,
    title: t`Statistics`,
    to: '/statistics',
    //roles: [Role.ADMIN],
    roles: [Role.AUTHENTICATED],
    inNavigation: true,
  },
  CLIENT_STATISTICS: {
    component: StatisticsWrapper,
    icon: BenefitsIcon,
    shortTitle: t`Statistics`,
    title: t`Statistics`,
    to: '/statistics/fun',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },
  /*CLIENT_BENEFITS: {
    component: BenefitsWrapper,
    icon: BenefitsIcon,
    shortTitle: t`Goals`,
    title: t`Goals`,
    to: '/goals',
    roles: [Role.USER],
    inNavigation: true,
  },
  ADMIN_ACTIVITY: {
    component: ActivityWrapper,
    icon: GoalsIcon,
    shortTitle: t`Activity`,
    title: t`Activity`,
    to: '/admin/activity',
    roles: [Role.ADMIN],
    inNavigation: true,
  },*/
  /*ADMIN_BENEFITS: {
    component: BenefitsManagementWrapper,
    icon: GoalsIcon,
    shortTitle: t`Goals`,
    title: t`Goals`,
    to: '/admin/goals',
    roles: [Role.ADMIN],
    inNavigation: true,
  },
  ADMIN_BENEFITS_NEW: {
    component: BenefitsManagementNewWrapper,
    shortTitle: t`New goal`,
    title: t`New goal`,
    to: '/admin/goals/new',
    roles: [Role.ADMIN],
  },*/
  CHALLENGE_ADMIN_CREATE: {
    component: ChallengeAdminWrapper,
    shortTitle: t`Create challenge`,
    title: t`Create challenge`,
    to: '/challenges/create',
    roles: [Role.USER, Role.ADMIN],
  },
  CHALLENGE_ADMIN_EDIT: {
    component: ChallengeAdminWrapper,
    shortTitle: t`Edit challenge`,
    title: t`Edit challenge`,
    to: '/challenges/:goalId/edit',
    roles: [Role.ADMIN],
  },
  /*ADMIN_STATISTICS: {
    component: StatisticsWrapper,
    icon: StatisticsIcon,
    shortTitle: t`Statistics`,
    title: t`Statistics`,
    to: '/admin/statistics',
    roles: [Role.ADMIN],
    inNavigation: true,
  },*/
  COMPANIES: {
    component: CompanyRankingWrapper,
    icon: CompaniesIcon,
    title: t`TOP 100`,
    to: '/ranking',
    roles: [Role.AUTHENTICATED],
    inNavigation: true,
  },
  ADMIN_USER: {
    component: UserManagementWrapper,
    icon: UserManagementIcon,
    shortTitle: t`Users`,
    title: t`User management`,
    to: '/admin/user-management',
    roles: [Role.ADMIN],
    inNavigation: false,
  },
  ADMIN_USER_NEW: {
    component: UserAdminWrapper,
    icon: UserManagementIcon,
    shortTitle: t`Users`,
    title: t`User management`,
    to: '/admin/users',
    roles: [Role.ADMIN],
    inNavigation: false,
  },
  /*ADMIN_USER_NEW: {
    component: UserManagementNewWrapper,
    shortTitle: t`New user`,
    title: t`User management new user`,
    to: '/admin/user-management/new',
    roles: [Role.ADMIN],
  },*/
  SETTINGS: {
    component: SettingsWrapper,
    icon: YourDetailsIcon,
    title: t`Your details`,
    to: '/settings',
    roles: [Role.AUTHENTICATED],
    inNavigation: false,
  },
}

export const MAPPED_ROUTES = Object.values(ROUTES)
